/**
 * Shared "source citation" envelope.
 *
 * Every numeric field surfaced on the public dashboard MUST trace back to a
 * source. This envelope is the wire shape — `sourceUrl` is the WHO/CDC/etc.
 * link, `sourceLabel` is the display name shown in the citation popover, and
 * `verifiedAt` is when our scraper or admin curator confirmed the number.
 */

import { z } from "zod";

export const sourceCitationSchema = z.object({
  sourceUrl: z.string().url(),
  sourceLabel: z.string().min(1),
  verifiedAt: z.date(),
});
export type SourceCitation = z.infer<typeof sourceCitationSchema>;
